<template>
  <div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <div>
          <top-header id="height2"></top-header>
          <main-menu id="height3"></main-menu>
        </div>
        <employee id="employee" style="padding-left:0px;padding-right:0px"></employee>
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import Employee from '@/components/Employee.vue'

export default {
  components: { MainMenu, TopHeader, Employee, BottomFooter },
  methods: {
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#employee').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted () {
    this.myFunction()
    this.menuheight()
  }
}
</script>
<style scoped>
</style>
